<template>
  <header class="page-product-header p-top-5 m-bot-3">
    <NavigationBackLink
      class="row-1"
      data-animate="header-content"
      :link="backLink"
    />

    <!-- Title -->
    <div class="row-1 m-top-5">
      <h1
        data-animate="header-title"
        class="title-m page-product-header__title"
      >
        {{ product.title }}
      </h1>
    </div>
    <!-- Designer / Download  -->
    <div
      class="row-1 m-top-24px page-product-sub-header"
      data-animate="header-content"
    >
      <p class="text-m">
        {{ product.designer.map((designer) => designer.title).join(', ') }}
      </p>

      <button
        class="button-round-1 page-product-header__download"
        @click="scrollToDownload"
      >
        <span>{{ $t(`pages.product.downloadTitle`) }}</span>
        <img
          src="~/assets/img/ico/ico-arrow-down-dark.svg"
          alt="Ico arrow down dark"
          width="12"
          height="13"
          data-animate="lang-switcher-ico"
        />
      </button>
    </div>
    <!-- Picture -->
    <div
      class="m-top-4 ratio-full-screen page-product-header__image"
      data-animate="header-image"
    >
      <WidgetPicture
        :image="{
          landscape: product.coverLandscape?.[0],
          portrait: product.coverMobile?.[0] || product.coverPortrait?.[0],
        }"
        :alt="product.productCover?.[0]?.title"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesProductHeader',
}
</script>

<script setup>
const props = defineProps({
  product: Object,
  navigationFrom: Object,
})

const { t } = useI18n()

const backLink = computed(() => {
  let backLink = {
    title: props.product.parent
      ? `${t('pages.product.backLink', {
          collection: props.product.parent.title,
        })}`
      : t('pages.product.backLinkCollection'),
    route: {
      name: props.product.parent
        ? 'product-family-slug'
        : 'typology-collections',
      params: props.product.parent
        ? { slug: props.product.parent.slug }
        : undefined,
    },
  }
  if (props.navigationFrom?.name?.includes('category')) {
    backLink = {
      title: t('pages.product.backLinkCategory'),
      route: props.navigationFrom.fullPath,
    }
  } else if (props.navigationFrom?.name?.includes('finishes')) {
    backLink = {
      title: t('pages.product.backLinkFinish'),
      route: props.navigationFrom.fullPath,
    }
  }
  return backLink
})

const scrollToDownload = () => {
  var target = document.getElementById('pageProductDownload')
  target.scrollIntoView({ behavior: 'smooth' })
}
</script>

<style lang="scss">
@import './style.scss';
</style>
